<div class="schedule-item">
    <div class="schedule-time">
        {{ time }}
    </div>

    <div [class]="'timeline ' + GettimeLineClass()">
        <span class="timeline-dot"></span>
        <span class="timeline-line"></span>
    </div>

    <div [class]="'appointment-card ' + getColorClass() ">
        <div class="appointment-header">
            <span class="appointment-icon"><i [class]="icon"></i></span>
            <span class="appointment-title">{{actionName}}</span>
        </div>

        <div class="appointment-name">
            {{name}}
        </div>

        <div class="appointment-subtitle">
            {{appDesc}}
        </div>
    </div>
</div>
